import { render, staticRenderFns } from "./ReservoirControl.vue?vue&type=template&id=24320325&scoped=true"
import script from "./ReservoirControl.vue?vue&type=script&lang=js"
export * from "./ReservoirControl.vue?vue&type=script&lang=js"
import style0 from "./ReservoirControl.vue?vue&type=style&index=0&id=24320325&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24320325",
  null
  
)

export default component.exports